import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export type XDPRedesignPhase1ContextType = {
  /** @deprecated This experiment has been replaced with individual flags */
  enableXDPRedesignPhase1: boolean;
  enableXDPRedesignKIM: boolean;
  enableXDPRedesignHero: boolean;
  enableXDPRedesignDescriptionRework: boolean;
};

export const XDPRedesignPhase1Context = createContext<XDPRedesignPhase1ContextType>({
  /** @deprecated This experiment has been replaced with individual flags */
  enableXDPRedesignPhase1: false,
  // These four epics are part of the phase 1.1 experiment
  enableXDPRedesignKIM: false,
  enableXDPRedesignHero: false,
  enableXDPRedesignDescriptionRework: false,
});

function XDPRedesignPhase1Provider({ children }: React.PropsWithChildren) {
  const [enableXDPRedesignPhase1] = useState(GrowthDiscoveryEpicClient.get('enableXDPRedesignPhase1'));
  const [enableXDPRedesignKIM] = useState(GrowthDiscoveryEpicClient.get('enableXDPRedesignKIM'));
  const [enableXDPRedesignHero] = useState(GrowthDiscoveryEpicClient.get('enableXDPRedesignHero'));
  const [enableXDPRedesignDescriptionRework] = useState(
    GrowthDiscoveryEpicClient.get('enableXDPRedesignDescriptionRework')
  );

  return (
    <XDPRedesignPhase1Context.Provider
      value={{
        enableXDPRedesignPhase1,
        enableXDPRedesignKIM,
        enableXDPRedesignHero,
        enableXDPRedesignDescriptionRework,
      }}
    >
      {children}
    </XDPRedesignPhase1Context.Provider>
  );
}

export const useXDPRedesignPhase1Data = () => {
  return (
    useContext(XDPRedesignPhase1Context) || {
      enableXDPRedesignPhase1: false,
      enableXDPRedesignKIM: false,
      enableXDPRedesignHero: false,
      enableXDPRedesignDescriptionRework: false,
    }
  );
};

export default XDPRedesignPhase1Provider;
